// import * as Sentry from '@sentry/react';
import { InsideType, ModuleType } from '../../../../constants/enum';
import {
  greaterOrEqual,
  lessOrEqual,
  roundTo,
} from '../../../../utils/geometry/epsilon';
import { parseJson } from '../../../../utils/string/parseJson';
import { InteractiveDimensionSystem } from '../../geometry/Dimensions';

class BaseNesting {
  constructor({ cabinetManager }) {
    this.cabinetManager = cabinetManager;
    if (cabinetManager.sceneManager)
      this.dimensionSystem = new InteractiveDimensionSystem(
        cabinetManager.sceneManager.camera,
        cabinetManager.sceneManager.renderer.domElement,
        cabinetManager.sceneManager.scene
      );
    // /**
    //  * kitchen profit margin for different suppliers
    //  */
    // this.profitMarginKitchenCabinet = {
    //   AC: 0.4, // M, L, Plastic
    //   ACC: 0.4, // Plywood
    //   KES: 0.4, // M, L
    // };

    // /**
    //  * wardrobe profit margin for different suppliers
    //  */
    // this.profitMarginWardrobeCabinet = {
    //   AC: 0.4, // M, L, Plastic
    //   ACC: 0.4, // Plywood
    //   KES: 0.4, // M, L
    // };

    // this.profitMargin = 0.4;

    // /**
    //  * clothes hanger profit margin
    //  */
    // this.clothesHangerPricePerMeter = 30000;

    // // Giá nguyên liệu (có thể lấy từ API sau này)
    // /** price of 17 edge banding | giá dán cạnh 17mm tính theo mét */
    // this.normalEdgeBandingPrice = 2800; // Giá dán cạnh (theo mét)
    // /** price of 34 edge banding | giá dán cạnh 34mm tính theo mét */
    // this.diffEdgeBandingPrice = 5800; // Giá dán cạnh (theo mét)
    // /** price of bevel edge banding | giá dán cạnh 45 độ tính theo mét */
    // this.bevelEdgeBandingPrice = 6800; // Giá dán cạnh 45 độ (theo mét)
    // /** price of glue | giá keo dán tính theo mét */
    // this.gluePrice = 0; // Giá keo dán (theo mét) tạm tính 0
    // /** price of hinge | giá bản lề tính theo cái */
    // this.hingePrice = 25000; // Giá bản lề
    // /** price of hinge 135 | giá bản lề 135 tính theo cái */
    // this.hinge135Price = 30000; // Giá bản lề 135
    // /** price of rail | giá ray tính theo mét */
    // this.railPrice = 40000; // Giá ray
    // /** price of connector | giá chốt cam tính theo cái */
    // this.connectorPrice = 700; // Giá chốt cam
    // /** price of screw | giá vít tính theo cái */
    // this.screwPrice = 0; // Giá vít (tạm tính 0)
    // /** price of mirror | giá gương tính theo m vuông */
    // this.mirrorPrice = 1200000; // Giá gương
    // /** price of seat cushion | giá đệm ngồi tính theo m2 */
    // this.seatCushionPrice = 1400000; // Giá đệm ngồi
    // //** price of led | Giá led âm/ led góc tính theo m dài */
    // this.ledPrice = 60000; // Giá led
    // //** price of light switch | Giá công tắc điện tính theo cái */
    // this.lightSwitchPrice = 80000; // Giá công tắc điện
    // //** price of led driver | Giá bộ nguồn led tính theo cái */
    // this.ledDriverPrice = 100000; // Giá bộ nguồn led

    // // Giá nhân công (có thể lấy từ API sau này)
    // /** price of design per board | giá nhân công thiết kế tính theo tấm ván */
    // this.designPerBoardPricing = 20000; // Giá nhân công trên mỗi tấm ván
    // /** price of CNC per board | giá CNC tính theo tấm ván */
    // this.cncPerBoardPricing = 40000; // Giá CNC trên mỗi tấm ván
    // /** price of labor normal edge | giá nhân công dán cạnh 17mm tính theo mét */
    // this.laborNormalEdgePricing = 4000; // Giá nhân công dán cạnh trên mỗi mét
    // /** price of labor diff edge | giá nhân công dán cạnh 34mm tính theo mét */
    // this.laborDiffEdgePricing = 15000; // Giá nhân công dán cạnh trên mỗi mét
    // /** price of labor edge 45 degrees | giá nhân công dán cạnh 45 độ tính theo mét */
    // this.laborEdge45Pricing = 15000; // Giá nhân công dán cạnh 45 độ trên mỗi mét
    // /** price of labor for packing | giá nhân công đóng gói tính theo tấm */
    // this.laborPackPricing = 30000; // Giá nhân công đóng gói trên mỗi tấm

    // /** price of labor for painting | giá nhân công sơn tính theo mét vuông */
    // this.normalDoorPrice = 250000; // Giá nhân công sơn trên mỗi mét vuông

    // /** price of glass inside the door */
    // // Tạm ẩn do kính tính theo texture
    // // this.glassInsideDoorPrice = 400000; // Giá kính bên trong cánh tủ tính theo mét vuông
    // /** price of paint 2k pano */
    // this.paint2KPanoPrice = 350000; // Giá sơn 2K tính theo mét vuông
    // /** price of paint no grain melamine pano */
    // this.paintNoGrainMelaminePanoPrice = 300000; // Giá sơn melamine không vân tính theo mét vuông
    // /** price of paint grain melamine pano */
    // this.paintGrainMelaminePanoPrice = 400000; // Giá sơn melamine có vân tính theo mét vuông
    // /** price of paint 2k Louver door */
    // this.paint2KLouverDoorPrice = 800000; // Giá sơn 2K lá sách tính theo mét vuông
    // /** price of paint no grain melamine Louver door */
    // this.paintNoGrainMelamineLouverDoorPrice = 700000; // Giá sơn melamine không vân cửa lá sách tính theo mét vuông
    // /** price of paint 2k milled door */
    // this.paint2KMilledDoorPrice = 300000; // Giá sơn 2K cửa phay tính theo mét vuông
    // /** price of paint no grain melamine milled door */
    // this.paintNoGrainMelamineMilledDoorPrice = 200000; // Giá sơn melamine không vân cửa phay tính theo mét vuông
    // /** price of aluminum door | giá nhôm tính theo mét vuông */
    this.alumDoorTripedGlassPrice = 300000; // Giá nhôm tính theo mét vuông

    // // Giá lắp đặt (có thể lấy từ API sau này)
    // /** price of assembly for kitchen lower | giá lắp đặt tủ bếp dưới tính theo mét dài */
    // this.assemblyKitchenLower = 350000; // Giá lắp đặt tủ bếp dưới trên mỗi mét dài
    // /** price of assembly for kitchen upper | giá lắp đặt tủ bếp trên tính theo mét dài */
    // this.assemblyKitchenUpper = 350000; // Giá lắp đặt tủ bếp trên trên mỗi mét dài
    // /** price of assembly for kitchen ceiling | giá lắp đặt tủ bếp trần tính theo mét dài */
    // this.assemblyKitchenCeiling = 500000; // Giá lắp đặt tủ bếp trên trên mỗi mét dài
    // /** price of assembly for wardrobe | giá lắp đặt tủ quần áo tính theo mét vuông */
    // this.assemblyWardrobe = 350000; // Giá lắp đặt tủ quần áo trên mỗi mét vuông
    // /** price of assembly for Decorative Cabinet | giá lắp đặt Tủ trang trí tính theo mét dài */
    // this.assemblyDisplayCabinet = 350000; // Giá lắp đặt Tủ trang trí theo mét vuông
    // /** price of assembly for TV cabinet */
    // this.assemblyTVCabinet = 350000; // Giá lắp đặt tủ TV trên mỗi mét dài
    // /** price of assembly for bed cabinet */
    // this.assemblyBed = 400000; // Giá lắp đặt tủ giường theo cái
    // /** price of assembly for shoe cabinet */
    // this.assemblyShoeCabinet = 350000; // Giá lắp đặt tủ giày trên mỗi mét vuông
    // /** price of assembly for desk */
    // this.assemblyDesk = 300000; // Giá lắp đặt bàn làm việc trên mỗi mét dài
    // /** price of assembly for vanity table */
    // this.assemblyVanityTable = 300000; // Giá lắp đặt bàn trang điểm trên mỗi mét dài
    // /** price of assembly for shelf */
    // this.assemblyShelf = 300000; // Giá lắp đợt kệ trang trí trên mỗi mét dài
    // /** price of assembly for bed drawer */
    // this.assemblyBedDrawer = 90000; // Giá lắp đặt ngăn kéo giường theo cái

    // //** price of shoe bench */
    // this.assemblyShoeBench = 400000; // Giá lắp đặt đôn ngồi theo mét
    // /** price of partition mirror*/
    // this.assemblyPartitionMirror = 500000; // Giá kính vách bếp tính theo mét vuông
    // //** price of partition melamine */
    // this.assemblyPartitionMelamine = 400000; // Giá lắp đặt vách melamine theo mét vuông
    // //** price of slatted partition */
    // this.assemblySlattedPartition = 700000; // Giá lắp đặt vách có khe theo mét vuông

    // /** price of curved block 2000 >= h >= 1000 */
    // this.curvedBlock3 = {
    //   AC: {
    //     M: 3000000,
    //     L: 3500000,
    //     Plastic: 3500000,
    //   },
    //   KES: {
    //     M: 2800000,
    //     L: 3000000,
    //   },
    //   ACC: 4000000,
    // };
    // /** price of curved block 1000 > h > 600 */
    // this.curvedBlock2 = {
    //   AC: {
    //     M: 2000000,
    //     L: 2500000,
    //     Plastic: 2500000,
    //   },
    //   KES: {
    //     M: 1500000,
    //     L: 1800000,
    //   },
    //   ACC: 2500000,
    // };
    // /** price of curved block 600 >= h > 300 */
    // this.curvedBlock1 = {
    //   AC: {
    //     M: 1000000,
    //     L: 1500000,
    //     Plastic: 1200000,
    //   },
    //   KES: {
    //     M: 800000,
    //     L: 1200000,
    //   },
    //   ACC: 1200000,
    // };

    this.EquipmentItem = [
      // InsideType.CLOTHES_HANGER,
      // InsideType.HANDLE,
      InsideType.ACCESSORY_GENERAL,
      InsideType.ACCESSORY_DISH_UPPER,
      InsideType.ACCESSORY_DISH_LOWER,
      InsideType.ACCESSORY_SINK, //Bồn rửa
      InsideType.ACCESSORY_FAUCET, //Bồn rửa
      InsideType.ACCESSORY_FRIDGE, //tủ lạnh
      InsideType.ACCESSORY_COOKER, //bếp từ
      InsideType.ACCESSORY_HOOD, //bếp từ
      InsideType.ACCESSORY_WASHER, //máy rửa chén
      InsideType.DOOR_CLONE, // Cửa clone để rescale tránh ảnh hưởng cửa chính
      86, //máy rửa chén
    ];
    this.LEDItem = [
      ModuleType.LED_DECOR,
      InsideType.LED_RECESSED,
      InsideType.LED_CORNER,
      InsideType.LED_EFFECT,
    ];
    this.HaveRail = [
      InsideType.DRAWER,
      InsideType.ACCESSORY_GENERAL,
      InsideType.ACCESSORY_DISH_LOWER,
    ];
  }

  COVER_THICKNESS = 0.017;
  TRIM_HEIGHT = 0.03;
  TRIM_WIDTH = 0.03;

  updateCabinetTrimSettings(cbTrim) {
    this.TRIM_HEIGHT = cbTrim.height;
    this.TRIM_WIDTH = cbTrim.width;
  }

  checkTrimCover = ({ cabinetCoverPos = {}, cabinetTrimPos = {} }) => {
    let bonusWidth = 0;
    let bonusHeight = 0;

    // + 17mm khi có ốp bìa  trái/phải
    if (cabinetCoverPos.left === false) {
      bonusWidth += this.COVER_THICKNESS;
    }
    if (cabinetCoverPos.right === false) {
      bonusWidth += this.COVER_THICKNESS;
    }

    // + 30mm khi có nẹp trái/phải
    if (cabinetTrimPos.left === true) {
      bonusWidth += this.TRIM_WIDTH;
    }
    if (cabinetTrimPos.right === true) {
      bonusWidth += this.TRIM_WIDTH;
    }

    // + 30mm khi có nẹp trên
    if (cabinetTrimPos.top === true) {
      bonusHeight += this.TRIM_HEIGHT;
    }

    return { bonusWidth, bonusHeight };
  };

  // updatePriceConfig(data) {
  //   const getPrice = name => {
  //     const item = data.find(item => item.name === name);
  //     return item;
  //   };

  //   /**
  //    * profit margin
  //    */
  //   const profitMargin = Number(getPrice('profitMargin')?.formula);
  //   /**
  //    * kitchen profit margin for different suppliers
  //    */
  //   const profitMarginKitchenCabinet = getPrice('profitMarginKitchenCabinet');
  //   /**
  //    * wardrobe profit margin for different suppliers
  //    */
  //   const profitMarginWardrobeCabinet = getPrice('profitMarginWardrobeCabinet');
  //   const clothesHangerPricePerMeter = getPrice('clothesHangerPricePerMeter');
  //   // Giá nguyên liệu (có thể lấy từ API sau này)
  //   /** price of 17 edge banding | giá dán cạnh 17mm tính theo mét */
  //   const normalEdgeBandingPrice = getPrice('normalEdgeBandingPrice'); // Giá dán cạnh (theo mét)
  //   /** price of 34 edge banding | giá dán cạnh 34mm tính theo mét */
  //   const diffEdgeBandingPrice = getPrice('diffEdgeBandingPrice'); // Giá dán cạnh (theo mét)
  //   /** price of bevel edge banding | giá dán cạnh 45 độ tính theo mét */
  //   const bevelEdgeBandingPrice = getPrice('bevelEdgeBandingPrice'); // Giá dán cạnh 45 độ (theo mét)
  //   /** price of glue | giá keo dán tính theo mét */
  //   const gluePrice = getPrice('gluePrice'); // Giá keo dán (theo mét) tạm tính 0
  //   /** price of hinge | giá bản lề tính theo cái */
  //   const hingePrice = getPrice('hingePrice'); // Giá bản lề
  //   /** price of hinge | giá bản lề tính theo cái */
  //   const hinge135Price = getPrice('hinge135Price'); // Giá bản lề135
  //   /** price of rail | giá ray tính theo mét */
  //   const railPrice = getPrice('railPrice'); // Giá ray
  //   /** price of connector | giá chốt cam tính theo cái */
  //   const connectorPrice = getPrice('connectorPrice'); // Giá chốt cam
  //   /** price of screw | giá vít tính theo cái */
  //   const screwPrice = getPrice('screwPrice'); // Giá vít (tạm tính 0)
  //   /** price of mirror | giá gương tính theo m vuông */
  //   const mirrorPrice = getPrice('mirrorPrice'); // Giá gương
  //   /** price of seat cushion | giá đệm ngồi tính theo m2 */
  //   const seatCushionPrice = getPrice('seatCushionPrice'); // Giá đệm ngồi

  //   // Giá nhân công (có thể lấy từ API sau này)
  //   /** price of design per board | giá nhân công thiết kế tính theo tấm ván */
  //   const designPerBoardPricing = getPrice('designPerBoardPricing'); // Giá nhân công trên mỗi tấm ván
  //   /** price of CNC per board | giá CNC tính theo tấm ván */
  //   const cncPerBoardPricing = getPrice('cncPerBoardPricing'); // Giá CNC trên mỗi tấm ván
  //   /** price of labor normal edge | giá nhân công dán cạnh 17mm tính theo mét */
  //   const laborNormalEdgePricing = getPrice('laborNormalEdgePricing'); // Giá nhân công dán cạnh trên mỗi mét
  //   /** price of labor diff edge | giá nhân công dán cạnh 34mm tính theo mét */
  //   const laborDiffEdgePricing = getPrice('laborDiffEdgePricing'); // Giá nhân công dán cạnh trên mỗi mét
  //   /** price of labor edge 45 degrees | giá nhân công dán cạnh 45 độ tính theo mét */
  //   const laborEdge45Pricing = getPrice('laborEdge45Pricing'); // Giá nhân công dán cạnh 45 độ trên mỗi mét
  //   /** price of labor for packing | giá nhân công đóng gói tính theo tấm */
  //   const laborPackPricing = getPrice('laborPackPricing'); // Giá nhân công đóng gói trên mỗi tấm

  //   /** price of labor for painting | giá nhân công sơn tính theo mét vuông */
  //   const normalDoorPrice = getPrice('normalDoorPrice'); // Giá nhân công sơn trên mỗi mét vuông

  //   /** price of glass inside the door */
  //   const glassInsideDoorPrice = getPrice('glassInsideDoorPrice'); // Giá kính bên trong cánh tủ tính theo mét vuông
  //   /** price of paint 2k pano */
  //   const paint2KPanoPrice = getPrice('paint2KPanoPrice'); // Giá sơn 2K tính theo mét vuông
  //   /** price of paint no grain melamine pano */
  //   const paintNoGrainMelaminePanoPrice = getPrice(
  //     'paintNoGrainMelaminePanoPrice'
  //   ); // Giá sơn melamine không vân tính theo mét vuông
  //   /** price of paint grain melamine pano */
  //   const paintGrainMelaminePanoPrice = getPrice('paintGrainMelaminePanoPrice'); // Giá sơn melamine có vân tính theo mét vuông
  //   /** price of paint 2k Louver door */
  //   const paint2KLouverDoorPrice = getPrice('paint2KLouverDoorPrice'); // Giá sơn 2K lá sách tính theo mét vuông
  //   /** price of paint no grain melamine Louver door */
  //   const paintNoGrainMelamineLouverDoorPrice = getPrice(
  //     'paintNoGrainMelamineLouverDoorPrice'
  //   ); // Giá sơn melamine không vân cửa lá sách tính theo mét vuông
  //   /** price of paint 2k milled door */
  //   const paint2KMilledDoorPrice = getPrice('paint2KMilledDoorPrice'); // Giá sơn 2K cửa phay tính theo mét vuông
  //   /** price of paint no grain melamine milled door */
  //   const paintNoGrainMelamineMilledDoorPrice = getPrice(
  //     'paintNoGrainMelamineMilledDoorPrice'
  //   ); // Giá sơn melamine không vân cửa phay tính theo mét vuông
  //   /** price of aluminum door | giá nhôm tính theo mét vuông */
  //   const alumDoorTripedGlassPrice = getPrice('alumDoorTripedGlassPrice'); // Giá nhôm tính theo mét vuông
  //   // Giá lắp đặt (có thể lấy từ API sau này)
  //   /** price of assembly for kitchen lower | giá lắp đặt tủ bếp dưới tính theo mét dài */
  //   const assemblyKitchenLower = getPrice('assemblyKitchenLower'); // Giá lắp đặt tủ bếp dưới trên mỗi mét dài
  //   /** price of assembly for kitchen upper | giá lắp đặt tủ bếp trên tính theo mét dài */
  //   const assemblyKitchenUpper = getPrice('assemblyKitchenUpper'); // Giá lắp đặt tủ bếp trên trên mỗi mét dài
  //   /** price of assembly for kitchen ceiling | giá lắp đặt tủ bếp trần tính theo mét dài */
  //   const assemblyKitchenCeiling = getPrice('assemblyKitchenCeiling'); // Giá lắp đặt tủ bếp trên trên mỗi mét dài
  //   /** price of assembly for wardrobe | giá lắp đặt tủ quần áo tính theo mét vuông */
  //   const assemblyWardrobe = getPrice('assemblyWardrobe'); // Giá lắp đặt tủ quần áo trên mỗi mét vuông
  //   /** price of assembly for Decorative Cabinet | giá lắp đặt Tủ trang trí tính theo mét dài */
  //   const assemblyDisplayCabinet = getPrice('assemblyDisplayCabinet'); // Giá lắp đặt Tủ trang trí theo mét vuông
  //   /** price of assembly for TV cabinet */
  //   const assemblyTVCabinet = getPrice('assemblyTVCabinet'); // Giá lắp đặt tủ TV trên mỗi mét dài
  //   /** price of assembly for bed cabinet */
  //   const assemblyBed = getPrice('assemblyBed'); // Giá lắp đặt tủ giường theo cái
  //   /** price of assembly for shoe cabinet */
  //   const assemblyShoeCabinet = getPrice('assemblyShoeCabinet'); // Giá lắp đặt tủ giày trên mỗi mét vuông
  //   /** price of assembly for desk */
  //   const assemblyDesk = getPrice('assemblyDesk'); // Giá lắp đặt bàn làm việc trên mỗi mét dài
  //   /** price of assembly for vanity table */
  //   const assemblyVanityTable = getPrice('assemblyVanityTable'); // Giá lắp đặt bàn trang điểm trên mỗi mét dài
  //   /** price of assembly for shelf */
  //   const assemblyShelf = getPrice('assemblyShelf'); // Giá lắp đợt kệ trang trí trên mỗi mét dài
  //   /** price of assembly for bed drawer */
  //   const assemblyBedDrawer = getPrice('assemblyBedDrawer'); // Giá lắp đặt ngăn kéo giường theo cái

  //   //** price of shoe bench */
  //   const assemblyShoeBench = getPrice('assemblyShoeBench'); // Giá lắp đặt đôn ngồi theo mét
  //   /** price of partition mirror*/
  //   const assemblyPartitionMirror = getPrice('assemblyPartitionMirror'); // Giá kính vách bếp tính theo mét vuông
  //   //** price of partition melamine */
  //   const assemblyPartitionMelamine = getPrice('assemblyPartitionMelamine'); // Giá lắp đặt vách melamine theo mét vuông
  //   //** price of slatted partition */
  //   const assemblySlattedPartition = getPrice('assemblySlattedPartition'); // Giá lắp đặt vách có khe theo mét vuông

  //   /** price of curved block 2000 >= h >= 1000 */
  //   const curvedBlock3 = getPrice('curvedBlock3');
  //   /** price of curved block 1000 > h > 600 */
  //   const curvedBlock2 = getPrice('curvedBlock2');
  //   /** price of curved block 600 >= h > 300 */
  //   const curvedBlock1 = getPrice('curvedBlock1');

  //   if (profitMargin) {
  //     this.profitMargin = profitMargin;
  //   }

  //   if (profitMarginKitchenCabinet) {
  //     try {
  //       this.profitMarginKitchenCabinet = parseJson(
  //         profitMarginKitchenCabinet.formula
  //       );
  //     } catch (error) {
  //       console.log('Error parsing profitMarginKitchenCabinet:', error);
  //     }
  //   }
  //   if (profitMarginWardrobeCabinet) {
  //     try {
  //       this.profitMarginWardrobeCabinet = parseJson(
  //         profitMarginWardrobeCabinet.formula
  //       );
  //     } catch (error) {
  //       console.log('Error parsing profitMarginWardrobeCabinet:', error);
  //     }
  //   }
  //   if (clothesHangerPricePerMeter) {
  //     try {
  //       this.clothesHangerPricePerMeter = clothesHangerPricePerMeter.price;
  //     } catch (error) {
  //       console.log('Error parsing profitMarginWardrobeCabinet:', error);
  //     }
  //   }
  //   if (normalEdgeBandingPrice) {
  //     this.normalEdgeBandingPrice = normalEdgeBandingPrice.price;
  //   }
  //   if (diffEdgeBandingPrice) {
  //     this.diffEdgeBandingPrice = diffEdgeBandingPrice.price;
  //   }
  //   if (bevelEdgeBandingPrice) {
  //     this.bevelEdgeBandingPrice = bevelEdgeBandingPrice.price;
  //   }
  //   if (gluePrice) {
  //     this.gluePrice = gluePrice.price;
  //   }
  //   if (hingePrice) {
  //     this.hingePrice = hingePrice.price;
  //   }
  //   if (hinge135Price) {
  //     this.hinge135Price = hinge135Price.price;
  //   }
  //   if (railPrice) {
  //     this.railPrice = railPrice.price;
  //   }
  //   if (connectorPrice) {
  //     this.connectorPrice = connectorPrice.price;
  //   }
  //   if (screwPrice) {
  //     this.screwPrice = screwPrice.price;
  //   }
  //   if (mirrorPrice) {
  //     this.mirrorPrice = mirrorPrice.price;
  //   }
  //   if (seatCushionPrice) {
  //     this.seatCushionPrice = seatCushionPrice.price;
  //   }

  //   // Labor prices
  //   if (designPerBoardPricing) {
  //     this.designPerBoardPricing = designPerBoardPricing.price;
  //   }
  //   if (cncPerBoardPricing) {
  //     this.cncPerBoardPricing = cncPerBoardPricing.price;
  //   }
  //   if (laborNormalEdgePricing) {
  //     this.laborNormalEdgePricing = laborNormalEdgePricing.price;
  //   }
  //   if (laborDiffEdgePricing) {
  //     this.laborDiffEdgePricing = laborDiffEdgePricing.price;
  //   }
  //   if (laborEdge45Pricing) {
  //     this.laborEdge45Pricing = laborEdge45Pricing.price;
  //   }
  //   if (laborPackPricing) {
  //     this.laborPackPricing = laborPackPricing.price;
  //   }

  //   if (normalDoorPrice) {
  //     this.normalDoorPrice = normalDoorPrice.price;
  //   }

  //   if (glassInsideDoorPrice) {
  //     this.glassInsideDoorPrice = glassInsideDoorPrice.price;
  //   }
  //   if (paint2KPanoPrice) {
  //     this.paint2KPanoPrice = paint2KPanoPrice.price;
  //   }
  //   if (paintNoGrainMelaminePanoPrice) {
  //     this.paintNoGrainMelaminePanoPrice = paintNoGrainMelaminePanoPrice.price;
  //   }
  //   if (paintGrainMelaminePanoPrice) {
  //     this.paintGrainMelaminePanoPrice = paintGrainMelaminePanoPrice.price;
  //   }
  //   if (paint2KLouverDoorPrice) {
  //     this.paint2KLouverDoorPrice = paint2KLouverDoorPrice.price;
  //   }
  //   if (paintNoGrainMelamineLouverDoorPrice) {
  //     this.paintNoGrainMelamineLouverDoorPrice =
  //       paintNoGrainMelamineLouverDoorPrice.price;
  //   }
  //   if (paint2KMilledDoorPrice) {
  //     this.paint2KMilledDoorPrice = paint2KMilledDoorPrice.price;
  //   }
  //   if (paintNoGrainMelamineMilledDoorPrice) {
  //     this.paintNoGrainMelamineMilledDoorPrice =
  //       paintNoGrainMelamineMilledDoorPrice.price;
  //   }
  //   if (alumDoorTripedGlassPrice) {
  //     this.alumDoorTripedGlassPrice = alumDoorTripedGlassPrice.price;
  //   }

  //   // Assembly prices
  //   if (assemblyKitchenLower) {
  //     this.assemblyKitchenLower = assemblyKitchenLower.price;
  //   }
  //   if (assemblyKitchenUpper) {
  //     this.assemblyKitchenUpper = assemblyKitchenUpper.price;
  //   }
  //   if (assemblyKitchenCeiling) {
  //     this.assemblyKitchenCeiling = assemblyKitchenCeiling.price;
  //   }
  //   if (assemblyWardrobe) {
  //     this.assemblyWardrobe = assemblyWardrobe.price;
  //   }
  //   if (assemblyDisplayCabinet) {
  //     this.assemblyDisplayCabinet = assemblyDisplayCabinet.price;
  //   }
  //   if (assemblyTVCabinet) {
  //     this.assemblyTVCabinet = assemblyTVCabinet.price;
  //   }
  //   if (assemblyBed) {
  //     this.assemblyBed = assemblyBed.price;
  //   }
  //   if (assemblyShoeCabinet) {
  //     this.assemblyShoeCabinet = assemblyShoeCabinet.price;
  //   }
  //   if (assemblyDesk) {
  //     this.assemblyDesk = assemblyDesk.price;
  //   }
  //   if (assemblyVanityTable) {
  //     this.assemblyVanityTable = assemblyVanityTable.price;
  //   }
  //   if (assemblyShelf) {
  //     this.assemblyShelf = assemblyShelf.price;
  //   }
  //   if (assemblyBedDrawer) {
  //     this.assemblyBedDrawer = assemblyBedDrawer.price;
  //   }

  //   if (assemblyShoeBench) {
  //     this.assemblyShoeBench = assemblyShoeBench.price;
  //   }
  //   if (assemblyPartitionMirror) {
  //     this.assemblyPartitionMirror = assemblyPartitionMirror.price;
  //   }
  //   if (assemblySlattedPartition) {
  //     this.assemblySlattedPartition = assemblySlattedPartition.price;
  //   }
  //   if (assemblyPartitionMelamine) {
  //     this.assemblyPartitionMelamine = assemblyPartitionMelamine.price;
  //   }

  //   if (curvedBlock3) {
  //     try {
  //       this.curvedBlock3 = parseJson(curvedBlock3.formula);
  //     } catch (error) {
  //       console.log('Error parsing curvedBlock3:', error);
  //     }
  //   }
  //   if (curvedBlock2) {
  //     try {
  //       this.curvedBlock2 = parseJson(curvedBlock2.formula);
  //     } catch (error) {
  //       console.log('Error parsing curvedBlock2:', error);
  //     }
  //   }
  //   if (curvedBlock1) {
  //     try {
  //       this.curvedBlock1 = parseJson(curvedBlock1.formula);
  //     } catch (error) {
  //       console.log('Error parsing curvedBlock1:', error);
  //     }
  //   }
  // }

  virtualize(containerId) {
    const containerAll = document.getElementById(containerId);
    if (!containerAll) {
      console.error(`Container with id "${containerId}" not found`);
      return null;
    }

    const container = document.createElement('div');
    containerAll.appendChild(container);
    // const formatCurrency = value =>
    //   `${roundTo(value, 0).toLocaleString('vi-VN')} đ`;
    // const formatPercent = value => `${roundTo((1 - value) * 100, 0)}%`;

    // const renderTableRows = rows =>
    //   rows
    //     .map(
    //       ({ category, item, value, unit = '', note = '' }) => `
    //       <tr>
    //         <td style="padding:12px 14px;border:1px solid #d9e2ec;vertical-align:top;">${category}</td>
    //         <td style="padding:12px 14px;border:1px solid #d9e2ec;vertical-align:top;">${item}</td>
    //         <td style="padding:12px 14px;border:1px solid #d9e2ec;vertical-align:top;font-weight:600;white-space:nowrap;">${value}</td>
    //         <td style="padding:12px 14px;border:1px solid #d9e2ec;vertical-align:top;">${unit}</td>
    //         <td style="padding:12px 14px;border:1px solid #d9e2ec;vertical-align:top;">${note}</td>
    //       </tr>
    //     `
    //     )
    //     .join('');

    // const getProfitMarginRows = (groupLabel, config) =>
    //   Object.entries(config || {}).map(([supplier, value]) => ({
    //     category: groupLabel,
    //     item: `Nhà cung cấp ${supplier}`,
    //     value: formatPercent(value),
    //     unit: 'Tỷ suất lợi nhuận',
    //     note: '',
    //   }));

    // const priceConfigRows = [
    //   ...getProfitMarginRows('TSLN tủ bếp', this.profitMarginKitchenCabinet),
    //   ...getProfitMarginRows(
    //     'TSLN tủ áo, tủ giày, tủ tv',
    //     this.profitMarginWardrobeCabinet
    //   ),
    //   {
    //     category: 'Phụ kiện',
    //     item: 'Thanh treo quần áo',
    //     value: formatCurrency(this.clothesHangerPricePerMeter),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Nguyên liệu',
    //     item: 'Dán cạnh 17mm',
    //     value: formatCurrency(this.normalEdgeBandingPrice),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Nguyên liệu',
    //     item: 'Dán cạnh 34mm',
    //     value: formatCurrency(this.diffEdgeBandingPrice),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Nguyên liệu',
    //     item: 'Dán cạnh 45 độ',
    //     value: formatCurrency(this.bevelEdgeBandingPrice),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Nguyên liệu',
    //     item: 'Keo dán',
    //     value: formatCurrency(this.gluePrice),
    //     unit: 'VNĐ/m',
    //     note: 'Tạm tính 0',
    //   },
    //   {
    //     category: 'Nguyên liệu',
    //     item: 'Bản lề',
    //     value: formatCurrency(this.hingePrice),
    //     unit: 'đ/cái',
    //     note: '',
    //   },
    //   {
    //     category: 'Nguyên liệu',
    //     item: 'Bản lề 135',
    //     value: formatCurrency(this.hinge135Price),
    //     unit: 'đ/cái',
    //     note: '',
    //   },
    //   {
    //     category: 'Nguyên liệu',
    //     item: 'Ray',
    //     value: formatCurrency(this.railPrice),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Nguyên liệu',
    //     item: 'Chốt cam',
    //     value: formatCurrency(this.connectorPrice),
    //     unit: 'đ/cái',
    //     note: '',
    //   },
    //   {
    //     category: 'Nguyên liệu',
    //     item: 'Vít',
    //     value: formatCurrency(this.screwPrice),
    //     unit: 'đ/cái',
    //     note: 'Tạm tính 0',
    //   },
    //   {
    //     category: 'Nguyên liệu',
    //     item: 'Gương',
    //     value: formatCurrency(this.mirrorPrice),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   {
    //     category: 'Nguyên liệu',
    //     item: 'Đệm ngồi',
    //     value: formatCurrency(this.seatCushionPrice),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   {
    //     category: 'Nhân công',
    //     item: 'Thiết kế theo tấm',
    //     value: formatCurrency(this.designPerBoardPricing),
    //     unit: 'đ/tấm',
    //     note: '',
    //   },
    //   {
    //     category: 'Nhân công',
    //     item: 'CNC theo tấm',
    //     value: formatCurrency(this.cncPerBoardPricing),
    //     unit: 'đ/tấm',
    //     note: '',
    //   },
    //   {
    //     category: 'Nhân công',
    //     item: 'Dán cạnh 17mm',
    //     value: formatCurrency(this.laborNormalEdgePricing),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Nhân công',
    //     item: 'Dán cạnh 34mm',
    //     value: formatCurrency(this.laborDiffEdgePricing),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Nhân công',
    //     item: 'Dán cạnh 45 độ',
    //     value: formatCurrency(this.laborEdge45Pricing),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Nhân công',
    //     item: 'Đóng gói',
    //     value: formatCurrency(this.laborPackPricing),
    //     unit: 'đ/tấm',
    //     note: '',
    //   },
    //   {
    //     category: 'Nhân công',
    //     item: 'Sơn cửa thường',
    //     value: formatCurrency(this.normalDoorPrice),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   {
    //     category: 'Nhân công',
    //     item: 'Sơn 2K pano',
    //     value: formatCurrency(this.paint2KPanoPrice),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   {
    //     category: 'Nhân công',
    //     item: 'Sơn melamine không vân pano',
    //     value: formatCurrency(this.paintNoGrainMelaminePanoPrice),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   {
    //     category: 'Nhân công',
    //     item: 'Sơn melamine có vân pano',
    //     value: formatCurrency(this.paintGrainMelaminePanoPrice),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   {
    //     category: 'Nhân công',
    //     item: 'Sơn 2K lá sách',
    //     value: formatCurrency(this.paint2KLouverDoorPrice),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   {
    //     category: 'Nhân công',
    //     item: 'Sơn melamine không vân lá sách',
    //     value: formatCurrency(this.paintNoGrainMelamineLouverDoorPrice),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   {
    //     category: 'Nhân công',
    //     item: 'Sơn 2K cửa phay',
    //     value: formatCurrency(this.paint2KMilledDoorPrice),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   {
    //     category: 'Nhân công',
    //     item: 'Sơn melamine không vân cửa phay',
    //     value: formatCurrency(this.paintNoGrainMelamineMilledDoorPrice),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Tủ bếp dưới',
    //     value: formatCurrency(this.assemblyKitchenLower),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Tủ bếp trên',
    //     value: formatCurrency(this.assemblyKitchenUpper),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Tủ bếp trần',
    //     value: formatCurrency(this.assemblyKitchenCeiling),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Tủ quần áo',
    //     value: formatCurrency(this.assemblyWardrobe),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Tủ trang trí',
    //     value: formatCurrency(this.assemblyDisplayCabinet),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Tủ TV',
    //     value: formatCurrency(this.assemblyTVCabinet),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Tủ giường',
    //     value: formatCurrency(this.assemblyBed),
    //     unit: 'đ/cái',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Tủ giày',
    //     value: formatCurrency(this.assemblyShoeCabinet),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Bàn làm việc',
    //     value: formatCurrency(this.assemblyDesk),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Bàn trang điểm',
    //     value: formatCurrency(this.assemblyVanityTable),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Đợt kệ trang trí',
    //     value: formatCurrency(this.assemblyShelf),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Ngăn kéo giường',
    //     value: formatCurrency(this.assemblyBedDrawer),
    //     unit: 'đ/cái',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Đôn ngồi',
    //     value: formatCurrency(this.assemblyShoeBench),
    //     unit: 'VNĐ/m',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Vách kính bếp',
    //     value: formatCurrency(this.assemblyPartitionMirror),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Vách melamine',
    //     value: formatCurrency(this.assemblyPartitionMelamine),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   {
    //     category: 'Lắp đặt',
    //     item: 'Vách lam',
    //     value: formatCurrency(this.assemblySlattedPartition),
    //     unit: 'VNĐ/m2',
    //     note: '',
    //   },
    //   ...Object.entries(this.curvedBlock3 || {}).flatMap(([supplier, value]) =>
    //     typeof value === 'number'
    //       ? [
    //           {
    //             category: 'Khối bo cong 2000 >= h >= 1000',
    //             item: `${supplier}`,
    //             value: formatCurrency(value),
    //             unit: 'VNĐ/khối',
    //             note: '',
    //           },
    //         ]
    //       : Object.entries(value).map(([type, price]) => ({
    //           category: 'Khối bo cong 2000 >= h >= 1000',
    //           item: `${supplier} - ${type}`,
    //           value: formatCurrency(price),
    //           unit: 'VNĐ/khối',
    //           note: '',
    //         }))
    //   ),
    //   ...Object.entries(this.curvedBlock2 || {}).flatMap(([supplier, value]) =>
    //     typeof value === 'number'
    //       ? [
    //           {
    //             category: 'Khối bo cong 1000 > h > 600',
    //             item: `${supplier}`,
    //             value: formatCurrency(value),
    //             unit: 'VNĐ/khối',
    //             note: '',
    //           },
    //         ]
    //       : Object.entries(value).map(([type, price]) => ({
    //           category: 'Khối bo cong 1000 > h > 600',
    //           item: `${supplier} - ${type}`,
    //           value: formatCurrency(price),
    //           unit: 'VNĐ/khối',
    //           note: '',
    //         }))
    //   ),
    //   ...Object.entries(this.curvedBlock1 || {}).flatMap(([supplier, value]) =>
    //     typeof value === 'number'
    //       ? [
    //           {
    //             category: 'Khối bo cong 600 >= h > 300',
    //             item: `${supplier}`,
    //             value: formatCurrency(value),
    //             unit: 'VNĐ/khối',
    //             note: '',
    //           },
    //         ]
    //       : Object.entries(value).map(([type, price]) => ({
    //           category: 'Khối bo cong 600 >= h > 300',
    //           item: `${supplier} - ${type}`,
    //           value: formatCurrency(price),
    //           unit: 'VNĐ/khối',
    //           note: '',
    //         }))
    //   ),
    // ];
    // const pricingConfigTable = priceConfigRows.length
    //   ? `
    //   <div style="margin-top:40px;display:flex;justify:flex-end;">
    //     <button
    //       type="button"
    //       data-price-toggle-btn
    //       style="padding:10px 14px;border:1px solid #cbd5e1;border-radius:10px;background:#f8fafc;color:#0f172a;font-size:14px;font-weight:600;cursor:pointer;"
    //     >
    //       Ẩn bảng cấu hình giá
    //     </button>
    //   </div>
    //   <div data-price-table-wrapper style="display:none;margin-top:12px;border:1px solid #d9e2ec;border-radius:16px;overflow:hidden;background:#fff;box-shadow:0 12px 30px rgba(15, 23, 42, 0.08);">
    //     <div style="padding:16px 20px;background:linear-gradient(135deg,#f8fafc 0%,#e2e8f0 100%);border-bottom:1px solid #d9e2ec;">
    //       <div style="font-size:18px;font-weight:700;color:#0f172a;">Bảng cấu hình đơn giá</div>
    //       <div style="margin-top:4px;font-size:13px;color:#475569;">Hiển thị toàn bộ thông số đơn giá đang dùng trong BaseNesting.</div>
    //     </div>
    //     <div style="overflow:auto;">
    //       <table style="width:100%;border-collapse:collapse;min-width:920px;background:#fff;">
    //         <thead>
    //           <tr style="background:#f8fafc;color:#0f172a;">
    //             <th style="padding:12px 14px;border:1px solid #d9e2ec;text-align:left;">Nhóm</th>
    //             <th style="padding:12px 14px;border:1px solid #d9e2ec;text-align:left;">Hạng mục</th>
    //             <th style="padding:12px 14px;border:1px solid #d9e2ec;text-align:left;">Giá trị</th>
    //             <th style="padding:12px 14px;border:1px solid #d9e2ec;text-align:left;">Đơn vị</th>
    //             <th style="padding:12px 14px;border:1px solid #d9e2ec;text-align:left;">Ghi chú</th>
    //           </tr>
    //         </thead>
    //         <tbody>
    //           ${renderTableRows(priceConfigRows)}
    //         </tbody>
    //       </table>
    //     </div>
    //   </div>
    // `
    //   : '';

    // container.innerHTML = `
    //     ${pricingConfigTable}`;

    // const toggleButton = container.querySelector('[data-price-toggle-btn]');
    // const tableWrapper = container.querySelector('[data-price-table-wrapper]');
    // if (toggleButton && tableWrapper) {
    //   toggleButton.addEventListener('click', () => {
    //     const isHidden = tableWrapper.style.display === 'none';
    //     tableWrapper.style.display = isHidden ? 'block' : 'none';
    //     toggleButton.textContent = isHidden
    //       ? 'Ẩn bảng cấu hình giá'
    //       : 'Hiện bảng cấu hình giá';
    //   });
    // }
  }

  // /**
  //  * @param {string} supplier AC | ACC | KES
  //  * @returns {number} profit margin
  //  */
  // getProfitMargin(supplier) {
  //   // if (this.cabinetManager?.currentCabinet === 'kitchen') {
  //   //   if (this.profitMarginKitchenCabinet[supplier]) {
  //   //     return 1 - (this.profitMarginKitchenCabinet[supplier] || 0);
  //   //   }
  //   // } else {
  //   //   if (this.profitMarginWardrobeCabinet[supplier]) {
  //   //     return 1 - (this.profitMarginWardrobeCabinet[supplier] || 0);
  //   //   }
  //   // }
  //   // // Sentry.captureException(new Error("Không thể xác định TSLN"));
  //   // return 1;
  //   return 1 - this.profitMargin;
  // }

  // /**
  //  * Calculate edge 17mm banding price total
  //  * @param {number} length
  //  * @returns
  //  */
  // getNormalEdgeBandingPriceTotal(length) {
  //   return length * this.normalEdgeBandingPrice;
  // }

  // /**
  //  * Calculate edge 34mm banding price total
  //  * @param {number} length
  //  * @returns
  //  */
  // getDiffEdgeBandingPriceTotal(length) {
  //   return length * this.diffEdgeBandingPrice;
  // }

  // /**
  //  * Calculate bevel edge banding price total
  //  * @param {number} length
  //  * @returns
  //  */
  // getBevelEdgeBandingPriceTotal(length) {
  //   return length * this.bevelEdgeBandingPrice;
  // }

  // /**
  //  * Calculate glue price total
  //  * @param {number} length
  //  * @returns
  //  */
  // getGluePriceTotal(length) {
  //   return length * this.gluePrice;
  // }

  // /**
  //  * Calculate hinge price total
  //  * @param {number} quantity
  //  * @returns
  //  */
  // getHingePriceTotal(quantity) {
  //   return quantity * this.hingePrice;
  // }

  // /**
  //  * Calculate hinge 135 price total
  //  * @param {number} quantity
  //  * @returns
  //  */
  // getHinge135PriceTotal(quantity) {
  //   return quantity * this.hinge135Price;
  // }

  // /**
  //  * Calculate rail price total
  //  * @param {number} length
  //  * @returns
  //  */
  // getRailPriceTotal(length) {
  //   return length * this.railPrice;
  // }

  // /**
  //  * Calculate connector price total
  //  * @param {number} quantity
  //  * @returns
  //  */
  // getConnectorPriceTotal(quantity) {
  //   return quantity * this.connectorPrice;
  // }

  // /**
  //  * Calculate screw price total
  //  * @param {number} quantity
  //  * @returns
  //  */
  // getScrewPriceTotal(quantity) {
  //   return quantity * this.screwPrice;
  // }

  // /**
  //  * Calculate design per board pricing total
  //  * @param {number} boardCount
  //  * @returns
  //  */
  // getDesignPerBoardPricingTotal(boardCount) {
  //   return boardCount * this.designPerBoardPricing;
  // }

  // /**
  //  * Calculate CNC per board pricing total
  //  * @param {number} boardCount
  //  * @returns
  //  */
  // getCNCPerBoardPricingTotal(boardCount) {
  //   return boardCount * this.cncPerBoardPricing;
  // }

  // /**
  //  * Calculate labor normal edge pricing total
  //  * @param {number} length
  //  * @returns
  //  */
  // getLaborNormalEdgePricingTotal(length) {
  //   return length * this.laborNormalEdgePricing;
  // }

  // /**
  //  * Calculate labor diff edge pricing total
  //  * @param {number} length
  //  * @returns
  //  */
  // getLaborDiffEdgePricingTotal(length) {
  //   return length * this.laborDiffEdgePricing;
  // }

  // /**
  //  * Calculate labor edge 45 degrees pricing total
  //  * @param {number} length
  //  * @returns
  //  */
  // getLaborEdge45PricingTotal(length) {
  //   return length * this.laborEdge45Pricing;
  // }

  // /**
  //  * Calculate labor pack pricing total
  //  * @param {number} boardCount
  //  * @returns
  //  */
  // getLaborPackPricingTotal(boardCount) {
  //   return boardCount * this.laborPackPricing;
  // }

  // /**
  //  * Calculate labor paint pricing total
  //  * @param {number} area
  //  * @returns
  //  */
  // getPaint2KNormalDoorPriceTotal(area) {
  //   return area * this.normalDoorPrice;
  // }

  // /**
  //  * Calculate aluminum door price total
  //  * @param {number} area
  //  * @returns
  //  */
  // getAlumDoorTripedGlassPriceTotal(area) {
  //   return area * this.alumDoorTripedGlassPrice;
  // }

  // /**
  //  * Calculate glass inside door price total
  //  * @param {number} area
  //  * @returns
  //  */
  // getGlassInsideDoorPriceTotal(area) {
  //   return area * this.glassInsideDoorPrice;
  // }

  // /**
  //  * Calculate paint 2k pano price total
  //  * @param {number} area
  //  * @returns
  //  */
  // getPaint2KPanoPriceTotal(area) {
  //   return area * this.paint2KPanoPrice;
  // }

  // /**
  //  * Calculate paint melamine pano price total
  //  * @param {number} area
  //  * @returns
  //  */
  // getPaintNoGrainMelaminePanoPriceTotal(area) {
  //   return area * this.paintNoGrainMelaminePanoPrice;
  // }

  // /**
  //  * Calculate paint grain melamine pano price total
  //  * @param {number} area
  //  * @returns
  //  */
  // getPaintGrainMelaminePanoPriceTotal(area) {
  //   return area * this.paintGrainMelaminePanoPrice;
  // }

  // /**
  //  * Calculate paint 2k louver door price total
  //  * @param {number} area
  //  * @returns
  //  */
  // getPaint2KLouverDoorPriceTotal(area) {
  //   return area * this.paint2KLouverDoorPrice;
  // }

  // /**
  //  * Calculate paint melamine louver door price total
  //  * @param {number} area
  //  * @returns
  //  */
  // getPaintNoGrainMelamineLouverDoorPriceTotal(area) {
  //   return area * this.paintNoGrainMelamineLouverDoorPrice;
  // }

  // /**
  //  * Calculate paint 2k milled door price total
  //  * @param {number} area
  //  * @returns
  //  */
  // getPaint2KMilledDoorPriceTotal(area) {
  //   return area * this.paint2KMilledDoorPrice;
  // }

  // /**
  //  * Calculate paint melamine milled door price total
  //  * @param {number} area
  //  * @returns
  //  */
  // getPaintNoGrainMelamineMilledDoorPriceTotal(area) {
  //   return area * this.paintNoGrainMelamineMilledDoorPrice;
  // }

  // /**
  //  * Calculate assembly kitchen lower total
  //  * @param {number} length
  //  * @returns
  //  */
  // getAssemblyKitchenLowerTotal(length) {
  //   return length * this.assemblyKitchenLower;
  // }

  // /**
  //  * Calculate assembly kitchen upper total
  //  * @param {number} length
  //  * @returns
  //  */
  // getAssemblyKitchenUpperTotal(length) {
  //   return length * this.assemblyKitchenUpper;
  // }

  // /**
  //  * Calculate assembly kitchen ceiling total
  //  * @param {number} length
  //  * @returns
  //  */
  // getAssemblyKitchenCeilingTotal(length) {
  //   return length * this.assemblyKitchenCeiling;
  // }

  // /**
  //  * Calculate assembly wardrobe total
  //  * @param {number} area
  //  * @returns
  //  */
  // getAssemblyWardrobeTotal(area) {
  //   return area * this.assemblyWardrobe;
  // }

  // /**
  //  * Calculate assembly Decorative Cabinet total
  //  * @param {number} area
  //  * @returns
  //  */
  // getAssemblyDisplayCabinetTotal(area) {
  //   return area * this.assemblyDisplayCabinet;
  // }

  // /**
  //  * Calculate assembly TV cabinet total
  //  * @param {number} length
  //  * @returns
  //  */
  // getAssemblyTVCabinetTotal(length) {
  //   return length * this.assemblyTVCabinet;
  // }

  // /**
  //  * Calculate assembly bed cabinet total
  //  * @param {number} quantity
  //  * @returns
  //  */
  // getAssemblyBedCabinetTotal(quantity) {
  //   return quantity * this.assemblyBed;
  // }

  // /**
  //  * Calculate assembly shoe cabinet total
  //  * @param {number} area
  //  * @returns
  //  */
  // getAssemblyShoeCabinetTotal(area) {
  //   return area * this.assemblyShoeCabinet;
  // }

  // /**
  //  * Calculate assembly desk total
  //  * @param {number} length
  //  * @returns
  //  */
  // getAssemblyDeskTotal(length) {
  //   return length * this.assemblyDesk;
  // }

  // /**
  //  * Calculate assembly vanity table total
  //  * @param {number} length
  //  * @returns
  //  */
  // getAssemblyVanityTableTotal(length) {
  //   return length * this.assemblyVanityTable;
  // }

  // /**
  //  * Calculate assembly shelf total
  //  * @param {number} length
  //  * @returns
  //  */
  // getAssemblyShelfTotal(length) {
  //   return length * this.assemblyShelf;
  // }

  // /**
  //  * Calculate assembly bed drawer total
  //  * @param {number} quantity
  //  * @returns
  //  */
  // getAssemblyBedDrawerTotal(quantity) {
  //   return quantity * this.assemblyBedDrawer;
  // }

  // /**   * Calculate curved block price total
  //  * @param {string} supplier AC | ACC | KES
  //  * @param {string} type M | L | Plastic
  //  * @param {number} height in mm
  //  * @returns
  //  */
  // getCurvedBlockPriceTotal({ supplier, type, height }) {
  //   if (!lessOrEqual(height, 1000) && lessOrEqual(height, 2000)) {
  //     const priceObj = this.curvedBlock3[supplier];
  //     if (typeof priceObj === 'object') {
  //       return priceObj[type] || 0;
  //     }
  //     return priceObj || 0;
  //   } else if (!lessOrEqual(height, 600) && lessOrEqual(height, 1000)) {
  //     const priceObj = this.curvedBlock2[supplier];
  //     if (typeof priceObj === 'object') {
  //       return priceObj[type] || 0;
  //     }
  //     return priceObj || 0;
  //     // } else if (!lessOrEqual(height, 300) && lessOrEqual(height, 600)) {
  //   } else if (lessOrEqual(height, 600)) {
  //     const priceObj = this.curvedBlock1[supplier];
  //     if (typeof priceObj === 'object') {
  //       return priceObj[type] || 0;
  //     }
  //     return priceObj || 0;
  //   }
  //   return 0;
  // }

  /**
   * Check hinge quantity based on door width and height
   * @param {number} width in meters
   * @param {number} height in meters
   * @returns {number} hinge quantity
   */
  checkHinge(width, height) {
    // Thống kê loại của để tính bản lề
    // Bản lề đối với cánh rộng từ 450mm trở xuống
    //- Dài dưới 1000mm	2 bản lề
    //- Dài từ 1000mm đến 1400mm	3 bản lề
    //- Dài từ 1400 đến 2000mm	4 bản lề
    //- Dài trên 2000mm	5 bản lề

    // Bản lề đối với cánh rộng trên 450mm
    //- Dài dưới 800mm	2 bản lề
    //- Dài từ 800mm đến 1400mm	3 bản lề
    //- Dài từ 1400 đến 2000mm	4 bản lề
    //- Dài trên 2000mm	5 bản lề
    if (lessOrEqual(width, 0.45)) {
      if (height < 1) {
        return 2;
      } else if (greaterOrEqual(height, 1) && height < 1.4) {
        return 3;
      } else if (greaterOrEqual(height, 1.4) && height < 2) {
        return 4;
      } else if (greaterOrEqual(height, 2)) {
        return 5;
      }
    } else {
      if (height < 0.8) {
        return 2;
      } else if (greaterOrEqual(height, 0.8) && height < 1.4) {
        return 3;
      } else if (greaterOrEqual(height, 1.4) && height < 2) {
        return 4;
      } else if (greaterOrEqual(height, 2)) {
        return 5;
      }
    }

    return 0;
  }

  /**
   * Check hinge quantity based on door width and height
   * @param {number} width in meters
   * @param {number} height in meters
   * @returns {number} hinge quantity
   */
  checkHingeCornerCabinet(height, hasMirror = false) {
    // Thống kê loại của để tính bản lề
    // <1000-1400 = 2 lề/cánh
    // >1400-1700 = 3 lề/cánh
    // >1700-2000 = 4 lề/cánh
    // >2000-2200 =5 lề/cánh
    // Cánh có gương + thêm 1 bản lề
    // FIXED [M2]: Cover the gap for 2.0 < height <= 2.2
    let hinges = 0;
    if (lessOrEqual(height, 1.4)) {
      hinges = 2;
    } else if (height > 1.4 && lessOrEqual(height, 1.7)) {
      hinges = 3;
    } else if (height > 1.7 && lessOrEqual(height, 2)) {
      hinges = 4;
    } else if (height > 2) {
      hinges = 5;
    }

    return hasMirror ? hinges + 1 : hinges;
  }

  // /**
  //  * Calculate wood product cost
  //  * @param {number} materialPrice
  //  * @param {number} laborPrice
  //  * @param {string} supplier AC | ACC | KES
  //  * @param {string} type kitchen | wardrobe | other
  //  * @returns
  //  */
  // calculateWoodProductCost({ materialPrice, laborPrice, supplier, type }) {
  //   return (
  //     ((materialPrice + laborPrice) / this.getProfitMargin(supplier, type)) *
  //     1.08
  //   );
  // }

  // /**
  //  * Calculate with profit margin
  //  * @param {number} basePrice
  //  * @param {string} supplier AC | ACC | KES
  //  * @param {string} type kitchen | wardrobe | other
  //  * @returns
  //  */
  // calculateWithProfitMargin({ basePrice, supplier }) {
  //   const type = this.cabinetManager?.currentCabinet?.type;
  //   const profitMargin = this.getProfitMargin(supplier, type);
  //   return (basePrice / profitMargin) * 1.08;
  // }

  // /**
  //  * Calculate total price
  //  * @param {number} woodProductPrice
  //  * @param {number} equipmentPrice
  //  * @returns
  //  */
  // calculateTotalPrice({ woodProductPrice, equipmentPrice }) {
  //   return woodProductPrice + equipmentPrice;
  // }
}

export default BaseNesting;
